import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { fmtDate } from "@/lib/format";
import { BellRing, Loader2 } from "lucide-react";

export const isOpenAgreement = (a) => a && (a.status === "verzonden" || a.status === "deels getekend");

export const RemindButton = ({ agreement: a, onDone, testId }) => {
  const [busy, setBusy] = useState(false);
  const [count, setCount] = useState(a.reminders_sent || 0);
  if (!isOpenAgreement(a)) return null;
  const remind = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/agreements/${a.id}/remind`);
      setCount(r.data.reminders_sent);
      toast.success(`Herinnering verstuurd naar ${r.data.recipients.join(", ")}`);
      onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Herinnering versturen mislukt"); }
    setBusy(false);
  };
  return (
    <Button size="sm" variant="outline" disabled={busy} onClick={remind} data-testid={testId || `remind-${a.id}`}
      className="border-[#C9A227] text-[#0F1E3D] hover:bg-[#C9A227]/10"
      title={a.last_reminder_at ? `Laatste herinnering ${fmtDate(a.last_reminder_at)}` : "Nog geen herinnering verstuurd"}>
      {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <BellRing className="h-4 w-4 mr-1.5 text-[#C9A227]" />} Herinnering{count ? ` (${count})` : ""}
    </Button>
  );
};
